import { useEffect, useRef } from 'react';
import './BrainOrb.css';

type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
type State = 'idle' | 'listening' | 'thinking';

interface BrainOrbProps {
  size?: Size;
  state?: State;
  className?: string;
  ariaLabel?: string;
}

export function BrainOrb({
  size = 'md',
  state = 'idle',
  className = '',
  ariaLabel,
}: BrainOrbProps) {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const apply = () => {
      if (mq.matches) {
        v.pause();
        v.currentTime = 0;
      } else {
        void v.play().catch(() => {});
      }
    };
    apply();
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, [state]);

  return (
    <span
      className={`brain-orb ${className}`.trim()}
      data-size={size}
      data-state={state}
      role={ariaLabel ? 'img' : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
    >
      <span className="brain-orb__halo" />
      <span className="brain-orb__core" />
      <span className="brain-orb__sheen" />
      <span className="brain-orb__highlight" />
      <video
        ref={videoRef}
        className="brain-orb__video"
        src={`/brain_orb_${state}.webm`}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        disablePictureInPicture
        disableRemotePlayback
        aria-hidden
      />
    </span>
  );
}
